export default {
	setErrors(errors){
		var self = this;
		this.$store.state.errors = errors;
		setTimeout(function(){
	        self.$store.state.errors = [];
	    }, 5000);
	},
	setMessages(messages){
		var self = this;
		this.$store.state.messages = messages;
		setTimeout(function(){
			self.$store.state.messages = [];
		}, 5000);
	},
	setWarnings(warnings) {
		var self = this;
		this.$store.state.warnings = warnings;
		setTimeout(function(){
			self.$store.state.warnings = [];
		}, 5000);
	}
}